/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type * as RPNInput from "react-phone-number-input";

import { numericPixels, radius } from "../../../../../global/emotion";

const flagStyle: Interpolation = {
  borderRadius: radius.xs,
  height: numericPixels[16],
  overflow: "hidden",
  width: numericPixels[24],
};

export const PhoneCountryFlag = ({ country }: RPNInput.FlagProps) => {
  const getUnicodeCountryFlag = (country) => {
    if (!country) return null;
    return (
      getRegionalIndicatorSymbol(country[0]) +
      getRegionalIndicatorSymbol(country[1])
    );
  };

  // Magic strings to get the regional indicator symbol
  // https://gitlab.com/catamphetamine/country-flag-icons/-/blob/master/source/unicode.js?ref_type=heads
  const getRegionalIndicatorSymbol = (letter) => {
    return String.fromCodePoint(
      0x1f1e6 - 65 + letter.toUpperCase().charCodeAt(0),
    );
  };

  return <span css={flagStyle}>{getUnicodeCountryFlag(country)}</span>;
};
PhoneCountryFlag.displayName = "PhoneCountryFlag";
